export const colors = {
  green: [
    '#6CB067', // 0
    '#6BAF67', // 1
    '#E9EFEF', // 2
    '#71B26E', // 3
    '#279A59', // 4
    '#57836C', // 5
    '#BED688', // 6
    '#6DAF67', // 7
    '#97C478', // 8
    '#BCD584', // 9
    '#5E9966', // 10
    '#297054', // 11
    '#4C7E63', // 12
    '#98C377', // 13
    '#A9BCB8', // 14
    '#BABDA3', // 15
    '#BDD484', // 16
    '#C8D5D2', // 17
    '#D6D7C7', // 18
    '#EDEBC5', // 19
    '#055138', // 20
    '#5D9765', // 21
    '#6D877E', // 22
    '#889F98', // 23
    '#A7D16B', // 24
    '#C7E17E', // 25
    '#C9CBAD', // 26
    '#CCD6D3', // 27
    '#DDE5AB', // 28
    '#4D7D63', // 29
    '#C7D6D1', // 30
    '#F2F4F2', // 31
    '#E7EDED', // 32
    '#ECEDED', // 33
    '#CCD0C1', // 34
    '', // 35
    '', // 36
    '#ffffff', // 37
    '#000000', // 38
  ],
  blue: [
    '#4B5DBC', // 0
    '#4B5DBC', // 1
    '#EEEFF8', // 2
    '#4B5DBC', // 3
    '#192C8C', // 4
    '#0A007A', // 5
    '#8F9CDE', // 6
    '#4B5DBC', // 7
    '#7889DF', // 8
    '#78A8DF', // 9
    '#132AA2', // 10
    '#001064', // 11
    '#00168B', // 12
    '#4A9DFF', // 13
    '#480090', // 14
    '#A6BFF1', // 15
    '#64D1FF', // 16
    '#CAC8D5', // 17
    '#8B7EE0', // 18
    '#B6CDEF', // 19
    '#2A0547', // 20
    '#2135A0', // 21
    '#6847C7', // 22
    '#4525A1', // 23
    '#4ABEFF', // 24
    '#93D8FF', // 25
    '#A2A6FF', // 26
    '#3B0069', // 27
    '#B6DAEF', // 28
    '#5D6A99', // 29
    '#C7CCD6', // 30
    '#F1F4FF', // 31
    '#EEEFF8', // 32
    '#EEEFF8', // 33
    '#2175F3', // 34
    '#ECEDED', // 35
    '', // 36
    '#ffffff', // 37
    '#000000', // 38
  ],
  red: [
    '#D11621', // 0
    '#D11621', // 1
    '#F9EDED', // 2
    '#D11621', // 3
    '#960000', // 4
    '#920009', // 5
    '#F7646C', // 6
    '#D11621', // 7
    '#E46C6C', // 8
    '#E68F8F', // 9
    '#BA213C', // 10
    '#7E0016', // 11
    '#A1000A', // 12
    '#FF4B4B', // 13
    '#493741', // 14
    '#B88787', // 15
    '#FF8585', // 16
    '#D5C8CC', // 17
    '#8B657A', // 18
    '#CD8F8F', // 19
    '#31000C', // 20
    '#BB0000', // 21
    '#6D4C5E', // 22
    '#5A3F4E', // 23
    '#FF6A6A', // 24
    '#FC9191', // 25
    '#9D778C', // 26
    '#564C52', // 27
    '#E09797', // 28
    '#A1000A', // 29
    '#EAAFAF', // 30
    '#FEF5F4', // 31
    '#FEF5F4', // 32
    '#FEF5F4', // 33
    '#DBC2C6', // 34
    '#A2003A', // 35
    '#D6C7CF', // 36
    '#ffffff', // 37
    '#000000', // 38
    '#ECEDED', // 39
    '#F7656C', // 40
  ],
  blueGreen: [
    '#04ADB2', // 0
    '#04ADB2', // 1
    '#E4EBF5', // 2
    '#04ADB2', // 3
    '#029197', // 4
    '#00647E', // 5
    '#91D05E', // 6
    '#04ADB2', // 7
    '#6FC06C', // 8
    '#91D05E', // 9
    '#028998', // 10
    '#028998', // 11
    '#4594A5', // 12
    '#6BCDB6', // 13
    '#ACCFB9', // 14
    '#6FC06C', // 15
    '#5EA9A6', // 16
    '#C8D5D2', // 17
    '#495E59', // 18
    '#61B071', // 19
    '#00647E', // 20
    '#04ADB2', // 21
    '#6D847E', // 22
    '#7BA08F', // 23
    '#85D2CD', // 24
    '#377F7E', // 25
    '#91D05E', // 26
    '#BDD9B0', // 27
    '#53A075', // 28
    '#4D7D63', // 29
    '#BDD9B0', // 30
    '#F1F4F9', // 31
    '#E9F6DF', // 32
    '#E3EAF4', // 33
    '#57B9BB', // 34
    '#d1d7e0', // 35
    '', // 36
    '#ffffff', // 37
    '#000000', // 38
  ],
  blueRed: [
    '#FC2F58', // 0
    '#2C1C7F', // 1
    '#F1E8EE', // 2
    '#2C1C7F', // 3
    '#190F5F', // 4
    '#2C1C7F', // 5
    '#FC2F58', // 6
    '#FC2F58', // 7
    '#C0335E', // 8
    '#F4415E', // 9
    '#602176', // 10
    '#E3CADE', // 11
    '#BFBCD1', // 12
    '#595093', // 13
    '#261A73', // 14
    '#CC2B63', // 15
    '#403583', // 16
    '#66206B', // 17
    '#F23064', // 18
    '#A62662', // 19
    '#A78BBB', // 20
    '#8C60AA', // 21
    '#F25D84', // 22
    '#F27796', // 23
    '#702E80', // 24
    '#66206B', // 25
    '#DF2E64', // 26
    '#473785', // 27
    '#862367', // 28
    '#BFBCD1', // 29
    '#BFBCD1', // 30
    '#F3EBF4', // 31
    '#F1E8EE', // 32
    '#F2BDC7', // 33
    '#8C86B2', // 34
    '#A9346B', // 35
    '#94266C', // 36
    '#ffffff', // 37
    '#000000', // 38
  ],
  blueYellow: [
    '#418CD2', // 0
    '#418CD2', // 1
    '#FFFAEC', // 2
    '#FFC630', // 3
    '#DA9000', // 4
    '#FF8F0B', // 5
    '#FFEF5A', // 6
    '#418CD2', // 7
    '#4EA8DA', // 8
    '#6CB4CB', // 9
    '#3A6AC6', // 10
    '#FF7939', // 11
    '#FFB38E', // 12
    '#9FD3F9', // 13
    '#FEE45C', // 14
    '#F1B4F4', // 15
    '#8ADF00', // 16
    '#7FD3C0', // 17
    '#FF5EA1', // 18
    '#D172D6', // 19
    '#EB4C00', // 20
    '#185FC9', // 21
    '#FFA1C9', // 22
    '#FFC52E', // 23
    '#6EBB00', // 24
    '#C0FF70', // 25
    '#E4286A', // 26
    '#F3FF6F', // 27
    '#C046C5', // 28
    '#3C5C8C', // 29
    '#99B9AE', // 30
    '#EBF5FF', // 31
    '#E6ECFA', // 32
    '#E6ECFA', // 33
    '#CECECE', // 34
    '#F5F5F5', // 35
    '#2B47AD', // 36
    '#ffffff', // 37
    '#000000', // 38
    '#ede4cc', // 39
    '#ECEDED', // 40
  ],
};
